$(document).on('ready', function () {
    $(".input-header-search").keyup(function () {
        var value = $(this).val();
        if (value !== ''){
            $(".clcik-remove-search").addClass("active");
        }else{
            $(".clcik-remove-search").removeClass("active");
        }

        $(".clcik-remove-search").click(function(){
            $(".input-header-search").val('');
            $(this).removeClass("active");

        });
    }).keyup();
    if($( window ).width() <= 767) {
        $(".collection_img_item").click(function () {
            if(!$(this).hasClass("is_hover")) {
                $(".collection_img_item").removeClass("is_hover");
                $(this).addClass("is_hover");
                return false;
            }
        });
    }


    $(".mobile-hamburger-icon").click(function(){
        $("body").addClass("befocontent");
        $("#shopify-section-theme_megamenu>ul").css('min-height', $( "body" ).height());
    });
    $(".btn.btn-checkout-cart.bottom").click(function(){
        $(".btn.btn-checkout-cart.top").trigger("click");
    });
    $(".right-cart .right-action .checkout-paypal").click(function(){
        $(".btn.btn-checkout-cart.top").trigger("click");
    });
    $(".show-form-review").click(function(){
        $(".spr-content").toggleClass("click");
    });
    $('body').on('click', '.yt-thumbnail', function () {
        var videoElement = $(this).parent('div').first().find('.yt-iframe');
        if (videoElement) {
            var link = videoElement.data('link');
            play(link, $(this).width(), $(this).height(), videoElement);
            $(this).hide();
        }
        $(".thumbnail.yt-thumbnail-v2 .background-opa").click(function() {
            $(this).addClass("end");
        });
    });
    $('body').on('click', '.yt-thumbnail-v2 .background-opa', function () {

        $(this).parent().addClass("end");
        $(this).parent().find("video").addClass("ul-submenu-true");
        $(this).parent().find("video").trigger('play');
    });
    $('body').on('click', '.yt-thumbnail-v2 .yt__image .group', function () {

        $(this).parent().find(".background-opa").trigger('click');
    });
    $(".site-header__cart-toggle.js-drawer-open-right").click(function() {
        $(".floating-notification").addClass("end");
    });

    $('.play-button').on('click', function () {
        $(this).parents('.row').first().find('.yt-thumbnail').first().trigger('click');
    });


    function play(link, width, height, elem) {
        var id = youtube_parser(link);
        var player = new YT.Player(elem.context, {
            height: height,
            width: width,
            videoId: id,
            playerVars: {
                autoplay: 1,
                controls: 0
            }
        });
        var fn = function(){ player.playVideo(); };
        setTimeout(fn, 1000);

    }
    function youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

    // Popular Product
    var popularSections = $('.vg_popular_product_wrapper');
    if (popularSections.length > 0) {
        $.each(popularSections, function (index, element) {
            var slideWrapper = $(element).children('.popular-products-swiper-container').first();
            var config = {};

            config['slidesPerView'] = parseInt(slideWrapper.data('desktop_slides_per_view'));
            config['slidesPerColumn'] = 1;
            config['click'] = true;
            config['breakpoints'] = {
                768: {
                    slidesPerView: 2, // or 'auto'
                    slidesPerColumn: 2,
                    slidesPerGroup: 3,
                    spaceBetween: 5,
                    grabCursor: true,
                }
            };

            config["navigation"] = {
                nextEl: '.p-swiper-button-next',
                prevEl: '.p-swiper-button-prev',
            };

            new Swiper(slideWrapper, config);
        });
    }

    $(function() {
        $('.group-item').matchHeight(false);

    });
    $(function() {
        $('.subcollection-item a p').matchHeight();
    });
    $(".click-output").click(function(){
        $(".discount").toggleClass("intro");
    });
    $(".active.menumobile").click(function(){
        $(".has-submenu .submenu").addClass("ul-submenu-true");
    });
    $(".active.menumobile ").click(function()
    {
        var li = $(this).parent();

        if (li.hasClass("fix-position")) {
            return false;
        }
        else {
            $('ul li').removeClass('fix-position');
            li.addClass("fix-position");
        }
        return false;

    });


    $(".mega-lever0 .hidden-desktop.click-function").click(function(){
        $(this).parent().addClass("active config-menu");
        $(this).parent().removeClass("backup");
    });
    $(".hidden-desktop.content-fiter").click(function(){
        $(".hidden-desktop.hidden-mobile").addClass("cative-block");
        $(".template-collection").addClass("active_body");
    });
    $(".click-out-product").click(function(){
        $(".hidden-desktop.hidden-mobile.cative-block").removeClass("cative-block");
        $(".template-collection.active_body").removeClass("active_body");
    });
    jQuery(document).on('click', function (e) {
        var containermenu = $('#mobile-menu li.mobile-menu-item.active');
        if (!containermenu.is(e.target)  && !$(".site-nav--mobile i").is(e.target)// if the target of the click isn't the container...
            && containermenu.has(e.target).length === 0) // ... nor a descendant of the container
        {
            $("#mobile-menu").removeClass("active");
            $("body").removeClass("befocontent");
            $("#mobile-menu .mega-lever0").removeClass("active");
            $("#mobile-menu .mega-lever0 ul li").removeClass("open-menu-sub");
        }
    });

    var slider = $('#myRange');
    var output = $('.demo');
    if (slider && output) {
        output.html(slider.value);

        slider.oninput = function() {
            output.html(this.value);
        }
    }

    var href;
    var url = location.href.substring(0, location.href.indexOf('?'));
    if(url){
        href = url.match(/([^\/]*)\/*$/)[1];
    }else{
        href = location.href.match(/([^\/]*)\/*$/)[1];
    }
    $(".no-bullets li a").each(function() {
        var current_url = this.href.substring(this.href.lastIndexOf('/') + 1);
        if (current_url === href) {
            $(this).parent().addClass('active');
        }
    });

    $(".row.four-columns .footer-title").click(function(){
        $(this).parent().toggleClass('active');
    });
    $(".js-drawer-open-left.mobile-hamburger-icon").click(function() {
        $("main.container").addClass("conten-js");
        $(".main-header").addClass("conten-js");
    });
    $("li.mobile-menu-item.active .main-menu").click(function() {
        $("main.container").removeClass("conten-js");
        $(".main-header").removeClass("conten-js");
        $("body").removeClass("befocontent");
        $("#mobile-menu").removeClass("active");
        $("#mobile-menu .mega-lever0").removeClass("active");
        $("#mobile-menu .mega-lever0 ul li").removeClass("open-menu-sub");

    });
});
